/* eslint-disable jsx-a11y/anchor-is-valid */
import { Grid } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import React, { useEffect } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { Link, Route } from 'react-router-dom'

import styles from '../../../../resources/theme/global'
import { useQueryParams } from '../../../../util/utils'
import { usePermissions } from '../../../../hooks/usePermission'
import colors from '../../../../assets/colors'

import { Filter } from './Filter'
import { List } from './List'
import { useLocation } from 'react-router-dom'
import { fetchServiceCategory } from '../../../service-category/ServiceCategoryActions'

export const Conversion = props => {
  const { classes } = props

  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canRead } = usePermissions()

  const location = useLocation()
  const dispatch = useDispatch()

  const filters = useQueryParams(location?.search)

  useEffect(() => {
    const finalFilters = {
      ...filters,
    }

    dispatch(
      fetchServiceCategory({
        ...finalFilters,
        rows: filters?.rows || 10,
        page: filters?.page || 1,
      })
    )
  }, [location])

  return (
    <>
      <Grid
        container
        className={classes?.pageHead}
        spacing={2}
        alignItems="center"
      >
        <Grid item xs={12}>
          <Typography
            variant="h4"
            style={{ fontSize: '20px' }}
            color={colors.primary}
          >
            Cadastro de Conversão
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Filter classes={classes} />
        </Grid>
      </Grid>

      {canRead('cashback-conversao', permissionUser) && (
        <List classes={classes} />
      )}
    </>
  )
}

export default withStyles(styles)(Conversion)
